import Tags from "./Tags";
import LocalStorage from './LocalStorage';

const TAGS_CACHE_KEY_PREFIX = "ONESIGNAL_SHOPIFY_TAG";
type SHOPIFY_TAG_KEYS_MAP = {
  [key in Required<keyof Tags>]: string;
};
const KEYS_MAP: SHOPIFY_TAG_KEYS_MAP = {
  item_count: `${TAGS_CACHE_KEY_PREFIX}_ITEM_COUNT`,
  item_name: `${TAGS_CACHE_KEY_PREFIX}_ITEM_NAME`,
  item_image_url: `${TAGS_CACHE_KEY_PREFIX}_ITEM_IMAGE_URL`,
  customer_id: `${TAGS_CACHE_KEY_PREFIX}_CUSTOMER_ID`,
};

export default class TagsCache {
  /**
   * Load the cached tags from LocalStorage.
   */
  public static load(): Tags|undefined {
    const itemCount = LocalStorage.get(KEYS_MAP.item_count);
    const itemName = LocalStorage.get(KEYS_MAP.item_name);
    const itemImageUrl = LocalStorage.get(KEYS_MAP.item_image_url);
    const customerId = LocalStorage.get(KEYS_MAP.customer_id);

    if (itemCount === null && itemName === null && itemImageUrl === null && customerId === null) {
      return undefined;
    }

    return {
      item_count: itemCount && parseInt(itemCount, 10) || 0,
      item_name: itemName || undefined,
      item_image_url: itemImageUrl || undefined,
      customer_id: customerId || undefined,
    };
  }

  /**
   * Store the tags in LocalStorage so we cache them between page loads.
   * 
   * @param tags The values to cache.
   */
  public static cache(tags: Tags): void {
    LocalStorage.set(KEYS_MAP.item_count, `${tags.item_count}`);

    if (!tags.item_name) {
      LocalStorage.delete(KEYS_MAP.item_name);
    } else {
      LocalStorage.set(KEYS_MAP.item_name, tags.item_name);
    }

    if (!tags.item_image_url) {
      LocalStorage.delete(KEYS_MAP.item_image_url);
    } else {
      LocalStorage.set(KEYS_MAP.item_image_url, tags.item_image_url);
    }

    if (!tags.customer_id) {
      LocalStorage.delete(KEYS_MAP.customer_id);
    } else {
      LocalStorage.set(KEYS_MAP.customer_id, tags.customer_id);
    }
  }
}
